export type Currency = "DKK";
export type Price = number;
export type PriceWithoutVat = number;
export type Vat = number;

export function vat(price: Price, currency: Currency = "DKK"): Vat {
  return price * 0.25;
}

export function priceAfterVat(price: Price): PriceWithoutVat {
  return price * 0.8;
}
